"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thing = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const PropertyValue_1 = require("./PropertyValue");
const ImageObject_1 = require("./ImageObject");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
let Thing = class Thing extends Shape_1.Shape {
    /**
     * An alias for the item.
     */
    get alternateName() {
        return this.getValue(schema_1.schema.alternateName);
    }
    set alternateName(val) {
        this.overwrite(schema_1.schema.alternateName, new models_1.Literal(val));
    }
    /**
     * A description of the item.
     */
    get description() {
        return this.getValue(schema_1.schema.description);
    }
    set description(val) {
        this.overwrite(schema_1.schema.description, new models_1.Literal(val));
    }
    /**
     * A sub property of description. A short description of the item used to disambiguate from other, similar items. Information from other properties (in particular, name) may be necessary for the description to be useful for disambiguation.
     */
    get disambiguatingDescription() {
        return this.getValue(schema_1.schema.disambiguatingDescription);
    }
    set disambiguatingDescription(val) {
        this.overwrite(schema_1.schema.disambiguatingDescription, new models_1.Literal(val));
    }
    /**
     * The identifier property represents any kind of identifier for any kind of Thing, such as ISBNs, GTIN codes, UUIDs etc. Schema.org provides dedicated properties for representing many of these, either as stringual strings or as URL (URI) links. See background notes for more details.
     */
    get identifier() {
        return this.getValue(schema_1.schema.identifier);
    }
    set identifier(val) {
        if (val instanceof PropertyValue_1.PropertyValue) {
            this.overwrite(schema_1.schema.identifier, val.namedNode);
        }
        else {
            this.overwrite(schema_1.schema.identifier, new models_1.Literal(val));
        }
    }
    /**
     * An image of the item.
     */
    get image() {
        return this.getOneAs(schema_1.schema.image, ImageObject_1.ImageObject);
        //return this.hasProperty(schema.image) ? new ImageObject(this.getValue(schema.image)) : null;
    }
    set image(val) {
        this.overwrite(schema_1.schema.image, val.node);
    }
    /**
     * Indicates a page (or other CreativeWork) for which this thing is the main entity being described. See background notes for details.
     */
    get mainEntityOfPage() {
        //TODO: this root Thing shape CANNOT refer to CreativeWork (which extends Thing) without creating cyclical dependencies
        // return this.hasProperty(schema.mainEntityOfPage) ? new CreativeWork(this.getValue(schema.mainEntityOfPage)) : null;
        return this.getOne(schema_1.schema.mainEntityOfPage);
    }
    /**
     * The name of the item.
     */
    get name() {
        return this.getValue(schema_1.schema.name);
    }
    set name(val) {
        this.overwrite(schema_1.schema.name, new models_1.Literal(val));
    }
    /**
     * TODO: this causes circular references, we need to find the target shape in an indirect way
     * Indicates a potential Action, which describes an idealized action in which this thing would play an 'object' role.
     */
    // get potentialAction(): Action {
    //   return this.hasProperty(schema.potentialAction) ? new Action(this.getValue(schema.potentialAction)) : null;
    // }
    /**
     * a reference NamedNode that unambiguously indicates the item's identity. E.g. the item's Wikipedia page, Wikidata entry, or official website.
     */
    get sameAs() {
        return this.getOne(schema_1.schema.sameAs);
    }
    /**
     * A CreativeWork or Event about this Thing.
     */
    //TODO: how to build get methods for 2 different value types? Note that data may not be loaded!
    // if we can assume some data is loaded. Do we validate the node against the shape?
    // get subjectOf(): CreativeWork | Event {
    //   return this.hasProperty(schema.subjectOf) ? new Event(this.getValue(schema.subjectOf)) : null;
    // }
    get subjectOf() {
        return this.getOne(schema_1.schema.subjectOf);
    }
    /**
     * URL of the item.
     */
    get url() {
        return this.getValue(schema_1.schema.url);
    }
    set url(val) {
        this.overwrite(schema_1.schema.url, new models_1.Literal(val.toString()));
    }
};
Thing.targetClass = schema_1.schema.Thing;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.alternateName,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Thing.prototype, "alternateName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.description,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Thing.prototype, "description", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.disambiguatingDescription,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Thing.prototype, "disambiguatingDescription", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.identifier,
        shape: PropertyValue_1.PropertyValue,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Thing.prototype, "identifier", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.image,
        shape: ImageObject_1.ImageObject,
    }),
    __metadata("design:type", ImageObject_1.ImageObject),
    __metadata("design:paramtypes", [ImageObject_1.ImageObject])
], Thing.prototype, "image", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.name,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Thing.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.url,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Thing.prototype, "url", null);
Thing = __decorate([
    package_1.linkedShape
], Thing);
exports.Thing = Thing;
//# sourceMappingURL=Thing.js.map